import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch} from "react-redux";
import {getSurveys} from "../actions/SurveyActions";

const useStyles = makeStyles({
    formControl: {
        width: "100%"
    }
});

const SurveySelect = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [data, setData] = useState([]);
    useEffect(() => {
        dispatch(getSurveys('A', setData));
    }, [dispatch]);

    return (
        <FormControl size="small" className={classes.formControl} required>
            <InputLabel id="select-label">Survey</InputLabel>
            <Select
                labelId="select-label"
                id="select"
                value={data && props.value || ''}
                onChange={e => props.onChange(e.target.value)}
            >
                {data.map((e => (<MenuItem key={e.key} value={e.key}>{e.value}</MenuItem>)))}
            </Select>
        </FormControl>
    )
};

SurveySelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number
};

export default SurveySelect;
